// Mock data for PH Janitorial Solutions landing page

export const mockServices = [
  {
    id: 1,
    title: "Commercial Cleaning",
    description: "Professional janitorial services for offices, retail stores, medical clinics, warehouses, and property management.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/245219/pexels-photo-245219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Daily/weekly janitorial services", "Floor care & polishing", "Washroom sanitation", "Garbage removal", "Disinfection & sanitization"]
  },
  {
    id: 2,
    title: "Residential Cleaning",
    description: "Comprehensive home cleaning services including regular housekeeping, deep cleaning, and move-in/out cleaning.",
    icon: "Home",
    image: "https://images.pexels.com/photos/6195114/pexels-photo-6195114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Regular housekeeping", "Deep cleaning", "Move-in/move-out cleaning", "Post-renovation cleaning", "Airbnb cleaning"]
  },
  {
    id: 3,
    title: "Specialized Services",
    description: "Expert specialized cleaning including carpet care, window cleaning, post-construction cleanup, and emergency services.",
    icon: "Sparkles",
    image: "https://images.pexels.com/photos/6195951/pexels-photo-6195951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Carpet & upholstery cleaning", "Window cleaning", "Post-construction cleanup", "Disinfection services", "Emergency cleaning"]
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "David Thompson",
    company: "Toronto Medical Clinic",
    role: "Clinic Manager",
    rating: 5,
    text: "PH Janitorial Solutions has been exceptional! Their local team is responsive and the service quality is consistently outstanding. Perfect for our medical facility.",
    avatar: "DT"
  },
  {
    id: 2,
    name: "Lisa Chen",
    company: "Residential Client - Vancouver",
    role: "Homeowner",
    rating: 5,
    text: "Amazing service from their Vancouver partner! They handle our Airbnb cleaning with such professionalism. Always reliable and thorough.",
    avatar: "LC"
  },
  {
    id: 3,
    name: "Robert Martinez",
    company: "Calgary Property Management",
    role: "Property Manager",
    rating: 5,
    text: "We manage multiple buildings and PH Janitorial Solutions delivers consistent quality across all locations. Their nationwide network is a game-changer.",
    avatar: "RM"
  }
];

export const mockProcess = [
  {
    step: 1,
    title: "Request a Quote",
    description: "Contact us to discuss your cleaning needs. We'll connect you with trusted local partners in your area.",
    icon: "ClipboardList"
  },
  {
    step: 2,
    title: "Custom Plan",
    description: "We create a tailored cleaning plan with competitive pricing and flexible service options to match your requirements.",
    icon: "FileCheck"
  },
  {
    step: 3,
    title: "Schedule Service",
    description: "Choose convenient scheduling - daily, weekly, monthly, or one-time cleaning. We work around your needs.",
    icon: "Calendar"
  },
  {
    step: 4,
    title: "Enjoy Clean Space",
    description: "Our trusted local experts deliver exceptional results. Experience reliable, efficient service across Canada.",
    icon: "CheckCircle"
  }
];

export const mockWhyChooseUs = [
  {
    id: 1,
    icon: "MapPin",
    title: "Nationwide Service Coverage",
    description: "Comprehensive cleaning services across Canada through our network of trusted local partners."
  },
  {
    id: 2,
    icon: "Building2",
    title: "Commercial & Residential Expertise",
    description: "From offices and retail to homes and condos - we handle all your cleaning needs professionally."
  },
  {
    id: 3,
    icon: "Users",
    title: "Trusted Local Partnerships",
    description: "Local experts who understand your community, ensuring fast response times and personalized service."
  },
  {
    id: 4,
    icon: "DollarSign",
    title: "Competitive Pricing",
    description: "Cost-effective solutions with customized packages and flexible long-term service agreements."
  },
  {
    id: 5,
    icon: "Clock",
    title: "Reliable & Efficient",
    description: "Consistent service quality with dependable scheduling and responsive local teams nationwide."
  },
  {
    id: 6,
    icon: "ShieldCheck",
    title: "Quality Guaranteed",
    description: "Professional expertise and high standards. We're committed to creating clean, safe, and healthy environments."
  }
];

export const mockContactInfo = {
  phone: "(647) 870-6110",
  email: "thiva@paramsothy.ca",
  address: "Serving All of Canada - Nationwide Coverage",
  hours: "Mon-Fri: 8AM-6PM, Sat: 9AM-3PM"
};

// Mock function to simulate booking submission
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking submitted:", bookingData);
      resolve({ success: true, message: "Booking request received! We'll connect you with a local partner shortly." });
    }, 1000);
  });
};

// Mock function to simulate quote request
export const submitQuoteRequest = async (quoteData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quote request submitted:", quoteData);
      resolve({ success: true, message: "Quote request received! Our local partner will contact you within 24 hours." });
    }, 1000);
  });
};
